import { Button } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useParams } from "react-router-dom";
import cat from "../../assets/images/cat.png";
import coffee from "../../assets/images/coffee.png";
import { authActions } from "../../store/actions/auth.actions";
import { organizacjeActions } from "../../store/actions/organizacje.actions";
import { IDRaksStore } from "../../store/store";
import { OdczytZaproszenia } from "../../store/types/organizacje";
import { ZaproszeniePageStyle } from "../../styles/ZaproszeniePageStyle";
import RaksLogo from "../../components/raksLogo";
import { IParams } from "../../store/types/auth";

interface ZaproszeniePageProps {
  onLogout: Function;
  onDajZaproszenie: Function;
  onOdrzuc: Function;
  zaproszenieError: string;
}

const ZaproszeniePage = (props: ZaproszeniePageProps) => {
  const { idorganizacji, idzaproszenia, host, redirect } =
    useParams() as IParams;
  const { onLogout, onDajZaproszenie, onOdrzuc, zaproszenieError } = props;
  const [zaproszenie, setZaproszenie] = useState({} as OdczytZaproszenia);
  const [odrzucono, setOdrzucono] = useState(false);
  const zProduktu = host && redirect;

  useEffect(() => {
    onLogout();
    onDajZaproszenie(idorganizacji, idzaproszenia).then(
      (dto: OdczytZaproszenia) => {
        if (dto) setZaproszenie(dto);
      }
    );
    // eslint-disable-next-line
  }, []);

  function odrzuc() {
    onOdrzuc(idorganizacji, idzaproszenia).then((res: boolean) => {
      if (res) setOdrzucono(true);
    });
  }

  function dajLinkAkceptacji() {
    if (zProduktu)
      return `/signupinvite/${idorganizacji}/${idzaproszenia}/${host}/${redirect}`;
    return `/signupinvite/${idorganizacji}/${idzaproszenia}`;
  }

  return (
    <ZaproszeniePageStyle>
      <header>
        <RaksLogo />
        <Link to={`/login`}>
          <Button variant="outlined" color="secondary">
            ZALOGUJ SIĘ
          </Button>
        </Link>
      </header>
      {odrzucono ? (
        <div className="info">
          <img src={cat} alt="cat" />
          <h4>Odrzuciłeś zaproszenie.</h4>
        </div>
      ) : zaproszenieError ? (
        <div className="info">
          <img src={cat} alt="cat" />
          <h4>Twoje zaproszenie wygasło lub zostało usunięte.</h4>
        </div>
      ) : zaproszenie.Email ? (
        <main>
          <img src={coffee} alt="coffee" />
          <h4>
            Masz zaproszenie
            {zaproszenie.NazwaZapraszajacego
              ? ` od ${zaproszenie.NazwaZapraszajacego} `
              : ` `}
            aby dołączyć do {zaproszenie.NazwaOrganizacji}
          </h4>
          <div className="buttons">
            <Link to={dajLinkAkceptacji()}>
              <Button variant="contained" color="secondary">
                PRZYJMIJ ZAPROSZENIE
              </Button>
            </Link>
            <Button variant="outlined" color="secondary" onClick={odrzuc}>
              ODRZUĆ ZAPROSZENIE
            </Button>
          </div>
        </main>
      ) : (
        <div />
      )}
    </ZaproszeniePageStyle>
  );
};

function mapStateToProps(store: IDRaksStore) {
  return {
    zaproszenieError: store.organizacje.zaproszenieError,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return {
    onLogout: () => dispatch(authActions.logout()),
    onDajZaproszenie: (idOrg: string, idzaproszenia: string) =>
      dispatch(organizacjeActions.dajZaproszenie(idOrg, idzaproszenia)),
    onOdrzuc: (idOrg: string, idzaproszenia: string) =>
      dispatch(organizacjeActions.odrzucZaproszenie(idOrg, idzaproszenia)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ZaproszeniePage);
